export const GOODSTACK_WEBSITE = 'https://goodstack.org'
